import { RegistrationValidationResponse } from "@/utils/types/NPS/Stepper/RegistrationDetails";
import { post } from "@/services/axiosUitils";

const baseUrl = "/nps/registration/validate";

class RegistrationDetailsValidateService {
  validateRegistrationDetails = async (
    ackId: string
  ): Promise<RegistrationValidationResponse> => {
    const response = await post<RegistrationValidationResponse>(`${baseUrl}/`, {
      ackId,
    });
    return response;
  };
}

const instance = new RegistrationDetailsValidateService();
export default instance;
